/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The SignInResponse model module.
 * @module model/SignInResponse
 * @version v1
 */
export class SignInResponse {
  /**
   * Constructs a new <code>SignInResponse</code>.
   * @alias module:model/SignInResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SignInResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SignInResponse} obj Optional instance to populate.
   * @return {module:model/SignInResponse} The populated <code>SignInResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SignInResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('account'))
        obj.account = ApiClient.convertToType(data['account'], Object);
      if (data.hasOwnProperty('messages'))
        obj.messages = ApiClient.convertToType(data['messages'], Object);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
SignInResponse.prototype.status = undefined;

/**
 * @member {Object} account
 */
SignInResponse.prototype.account = undefined;

/**
 * @member {Object} messages
 */
SignInResponse.prototype.messages = undefined;

